// import React, { useState } from "react";
// import axios from "axios";
// import { Button, TextField, MenuItem, Select, FormControl, InputLabel, Box } from "@mui/material";
// import { base_url } from "../../utils";
// import { getAccesstoken } from "../../helpers/utils";

// const DownloadRchLogs = () => {
//   const [downloadType, setDownloadType] = useState("date"); 
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");

//   const handleDownloadCSV = async () => {
//     let payload = {};

//     if (downloadType === "date") {
//       if (!fromDate || !toDate) {
//         alert("Please select both From and To dates.");
//         return;
//       }

//       const from = new Date(fromDate);
//       const to = new Date(toDate);
//       if (from > to) {
//         alert("From date cannot be later than To date.");
//         return;
//       }

//       payload = {
//         start_date: fromDate,
//         end_date: toDate,
//         month: from.getMonth() + 1,
//         year: from.getFullYear(),
//       };
//     } else if (downloadType === "month") {
//       if (!month || !year) {
//         alert("Please select both Month and Year.");
//         return;
//       }
//       payload = { month, year };
//     } else if (downloadType === "year") {
//       if (!year) {
//         alert("Please select a Year.");
//         return;
//       }
//       payload = { year };
//     }

//     try {
//       const token = getAccesstoken();
//       const response = await axios.post(`${base_url}/digilocker/download_credit_recharge_history_logs`, payload, {
//         responseType: "blob",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.data || response.data.size === 0) {
//         alert("No data found for the selected range.");
//         return;
//       }

//       const fileName =
//         downloadType === "date"
//           ? `credit_logs_${fromDate}_to_${toDate}.csv`
//           : downloadType === "month"
//           ? `credit_logs_${month}_${year}.csv`
//           : `credit_logs_${year}.csv`;

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error("Error downloading CSV:", error);
//       alert("Failed to download CSV.");
//     }
//   };

//   return (
//     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
//       {/* Dropdown for selection */}
//       <FormControl sx={{ minWidth: 150 }}>
//         {/* <InputLabel>Download Type</InputLabel> */}
//         <Select value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
//           <MenuItem value="date">Date Wise</MenuItem>
//           <MenuItem value="month">Month Wise</MenuItem>
          
//         </Select>
//       </FormControl>

//       {/* Conditional rendering based on selection */}
//       {downloadType === "date" && (
//         <>
//           <TextField
//             label="From Date"
//             type="date"
//             InputLabelProps={{ shrink: true }}
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             sx={{ minWidth: 160 }}
//           />
//           <TextField
//             label="To Date"
//             type="date"
//             InputLabelProps={{ shrink: true }}
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             sx={{ minWidth: 160 }}
//           />
//         </>
//       )}

//       {downloadType === "month" && (
//         <>
//           <FormControl sx={{ minWidth: 120 }}>
//             <InputLabel>Month</InputLabel>
//             <Select value={month} onChange={(e) => setMonth(e.target.value)}>
//               {Array.from({ length: 12 }, (_, i) => (
//                 <MenuItem key={i + 1} value={i + 1}>
//                   {new Date(0, i).toLocaleString("default", { month: "long" })}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl sx={{ minWidth: 120 }}>
//       <InputLabel>Year</InputLabel>
//       <Select value={year} onChange={(e) => setYear(e.target.value)}>
//         {Array.from({ length: 6 }, (_, i) => {
//           const currentYear = new Date().getFullYear();
//           const yearValue = currentYear - i;
//           return (
//             <MenuItem key={yearValue} value={yearValue}>
//               {yearValue}
//             </MenuItem>
//           );
//         })}
//       </Select>
//     </FormControl>
//         </>
//       )}

      

//       {/* Download Button */}
//       <Button variant="contained" color="primary" onClick={handleDownloadCSV}>
//         Download CSV
//       </Button>
//     </Box>
//   );
// };

// export default DownloadRchLogs;

import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { base_url } from "../../utils";
import { getAccesstoken } from "../../helpers/utils";

const DownloadCreditLogs = () => {
  const [downloadType, setDownloadType] = useState("date");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const handleDownloadCSV = async () => {
    let payload = {};

    if (downloadType === "date") {
      if (!fromDate || !toDate) {
        alert("Please select both From and To dates.");
        return;
      }
      const from = new Date(fromDate);
      const to = new Date(toDate);
      if (from > to) {
        alert("From date cannot be later than To date.");
        return;
      }
      payload = {
        start_date: fromDate,
        end_date: toDate,
        month: from.getMonth() + 1,
        year: from.getFullYear(),
      };
    } else if (downloadType === "month") {
      if (!month || !year) {
        alert("Please select both Month and Year.");
        return;
      }
      payload = { month, year };
    }

    try {
      const token = getAccesstoken();
      const response = await axios.post(
        `${base_url}/digilocker/download_credit_recharge_history_logs`,payload,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data || response.data.size === 0) {
        alert("No data found for the selected range.");
        return;
      }

      const fileName =
        downloadType === "date"
          ? `credit_logs_${fromDate}_to_${toDate}.csv`
          : `credit_logs_${month}_${year}.csv`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading CSV:", error);
      alert("Failed to download CSV.");
    }
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center",justifyContent:"center" }}>
      <Box sx={{ display: "flex",flexDirection:"column", flexWrap: "wrap" }}>
     <h6 sx={{display:"flex", alignItems:"center"}}>Download Type</h6>
      <ToggleButtonGroup
        value={downloadType}
        exclusive
        onChange={(e,newType) => newType && setDownloadType(newType)}
        sx={{ mb: 2 }}
        > 
        <ToggleButton value="date" sx={{ height: "30px", "& .MuiInputBase-root": { height: "30px" } }}>Date Wise</ToggleButton>
        <ToggleButton value="month" sx={{ height: "30px", "& .MuiInputBase-root": { height: "30px" } }}>Month Wise</ToggleButton>
      </ToggleButtonGroup>
        </Box>
        

      {downloadType === "date" && (
        <>
          <TextField
            label="From Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            sx={{ minWidth: 120 , height: "40px", "& .MuiInputBase-root": { height: "40px" } }}
          />
          <TextField
            label="To Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            sx={{ minWidth: 120, height: "40px", "& .MuiInputBase-root": { height: "40px" } }}
          />
        </>
      )}

      {downloadType === "month" && (
        <>
          <FormControl sx={{ minWidth: 120 , height: "50px", "& .MuiInputBase-root": { height: "50px" } }}>
            <InputLabel>Month</InputLabel>
            <Select value={month} onChange={(e) => setMonth(e.target.value)}>
              {Array.from({ length: 12 }, (_, i) => (
                <MenuItem key={i + 1} value={i + 1}>
                  {new Date(0, i).toLocaleString("default", { month: "long" })}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 120 , height: "50px", "& .MuiInputBase-root": { height: "50px" }  }}>
            <InputLabel>Year</InputLabel>
            <Select value={year} onChange={(e) => setYear(e.target.value)}>
              {Array.from({ length: 6 }, (_, i) => {
                const currentYear = new Date().getFullYear();
                const yearValue = currentYear - i;
                return (
                  <MenuItem key={yearValue} value={yearValue}>
                    {yearValue}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </>
      )}
      {/* Download Button */}
      <Button variant="contained" color="primary" onClick={handleDownloadCSV}>
        Download CSV
      </Button>
    </Box>
  );
};
export default DownloadCreditLogs;
